import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import ReportIcon from '@mui/icons-material/Report';
import { updateAnularFichaje } from '../../services/apis';
export const DialogAnularFichaje = ({ open, setOpen, fichaje, fichajesUsuario, usuarioId }) => {

    const sendAnularFichaje = async (fichaje) => {
        console.log(fichaje);

        try {
            const response = await updateAnularFichaje(fichaje);
            console.log(response);

            if (response.success) {
                fichajesUsuario(usuarioId);

                setOpen(null)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                >
                    <Typography variant='h5'>
                        <ReportIcon color='warning' sx={{ mb: -1.5, fontSize: 40 }} /> Anular fichaje
                    </Typography>

                    <Divider sx={{ minWidth: '100%', my: 1 }} />
                </Grid>
            </DialogTitle>

            <DialogContent>
                <Typography variant='body1'>
                    ¿Estás seguro de que deseas anular este fichaje? Esta acción <strong>no se puede deshacer.</strong>
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => sendAnularFichaje(fichaje)} autoFocus variant='contained' color='warning'>
                    Aceptar <ReportIcon sx={{ mt: -0.3, fontSize: 25, ml: 0.5 }} />
                </Button>
                <Button onClick={() => setOpen(null)} variant='text' color='primary'>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
